import SyncSet from './src/sync-set';

export default SyncSet;
